import React from 'react';

/**
 * Global reusable step/progress dot indicator (e.g. wizard steps within the "magic" template).
 * Props: total (number of steps), activeIndex (0-based current step), className
 */
const StepDots = ({ total = 3, activeIndex = 0, className = '' } = {}) => {
  if (total <= 1) return null;

  return (
    <div className={`step-dots ${className}`.trim()} role="tablist" aria-label="Step progress">
      {Array.from({ length: total }).map((_, index) => (
        <span key={index} className={`step-dot${index === activeIndex ? ' step-dot--active' : ''}`} />
      ))}
    </div>
  );
};

export default StepDots;
